import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

/* eslint-disable no-redeclare */
export function elegir() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length >= 2) {
    if (args[0] === true) {
      return args[1];
    }

    return elegir.apply(void 0, _toConsumableArray(args.slice(2)));
  }
}
//# sourceMappingURL=index.js.map